module.exports = __webpack_public_path__ + "media/images/demo/icon-menu-023e1132f3d91cb12ef0af1019376c8d.jpg";